export const formats = {
  date: 'DD/MM/YYYY',
}
